import { configs } from "../configs"
import { DefaultImage } from "../modules/ui-builder/external-components"

export function generateImagePath(
  inputPath: string | null | undefined,
  sizeType: "thumbnail" | "small" | "medium" | "large" | "original",
) {
  if (!inputPath) {
    return DefaultImage
  }

  // Define allowed size types
  const allowedSizeTypes = ["thumbnail", "small", "medium", "large", "original"]

  if (sizeType === "original") {
    return `${configs.API_URL}${inputPath}`
  }

  // Validate sizeType
  if (!allowedSizeTypes.includes(sizeType)) {
    throw new Error(`Invalid size type. Allowed values are: ${allowedSizeTypes.join(", ")}`)
  }

  // Try-catch to handle errors and fallback to original if needed
  try {
    // Extract the filename from the input path
    const filename = inputPath.split("/").pop() as string

    // Construct the new path with the size type
    return `${configs.API_URL}${inputPath.replace(filename, `${sizeType}_${filename}`)}`
  } catch (error) {
    // If any error occurs, return the original image
    console.error("Error generating image path, falling back to original image:", error)
    return `${configs.API_URL}${inputPath}`
  }
}
